import { api } from './api';

export interface LLDAnalytics {
 totalCompleted: number;
 averageScore: number;
 dimensionAverages: Record<string, number>;
 weeklyTrends: {
  week: string;
  problemsCompleted: number;
  averageScore: number;
 }[];
 weakAreas: {
  dimension: string;
  averageScore: number;
  problemCount: number;
 }[];
 strongAreas: {
  dimension: string;
  averageScore: number;
  problemCount: number;
 }[];
 recentEvaluations: {
  problemId: string;
  title: string;
  overallScore: number;
  submittedAt: string;
 }[];
}

export interface LLDRecommendation {
 problemId: string;
 title: string;
 difficulty: string;
 category: string;
 reason: string;
}

class LLDAnalyticsService {
 /**
  * Get aggregated analytics (scores, trends, weak areas).
  * Requires JWT authentication.
  */
 async getAnalytics(): Promise<LLDAnalytics> {
  return await api.get('/lld-practice/evaluation/analytics');
 }

 /**
  * Get problem recommendations for a specific weak dimension.
  * Requires JWT authentication.
  */
 async getRecommendations(dimension: string): Promise<LLDRecommendation[]> {
  const queryParams = new URLSearchParams();
  queryParams.append('dimension', dimension);
  return await api.get(`/lld-practice/evaluation/analytics?dimension=${encodeURIComponent(dimension)}`);
 }
}

export const lldAnalyticsService = new LLDAnalyticsService();
export default lldAnalyticsService;
